export default {
  lazyImages: true,
  filterBy: 'all',
  projects: [],
  lastPosts: []
}
